import { createContext } from "react";

export const SearchRefinementContext = createContext();